import { render } from "./AddTenderCategory.vue?vue&type=template&id=ddc12110&scoped=true"
import script from "./AddTenderCategory.vue?vue&type=script&lang=js"
export * from "./AddTenderCategory.vue?vue&type=script&lang=js"

import "./AddTenderCategory.vue?vue&type=style&index=0&id=ddc12110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddc12110"]])

export default __exports__